<template>
    <div>
        <div class="row">
            <div class="col-md-12 card-wrapper">
                <div class="card">
                    <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('BACKUP')}}</div>
                    <div class="card-body bg-light">
                        <div class="row">
                            <div class="col-md-6">
                                <div v-html="$ml.get('BACKUP_WARN')"></div>
                            </div>
                            <div class="col-md-6">
                                <div class="card" style="width: 100%">
                                    <div class="card-header crm-modal-header d-flex justify-content-between align-items-center">
                                        <span>{{$ml.get('VERSION_DATE')}}</span>
                                        <button type="button" class="btn btn-primary" @click="getDLLinkForCompanyBackupsF()">{{$ml.get('BACKUP')}}</button>
                                    </div>
                                    <div class="restore-list-wrapper">
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item list-group-item-action d-flex align-items-center" v-for="(day,index) in lastWeek" v-bind:key="index" @click="selectedDate=$moment(day).format('YYYY-MM-DD')">
                                                <input type="radio" v-model="selectedDate" :value="$moment(day).format('YYYY-MM-DD')"/> 
                                                <span class="pl-2">{{day}} {{$ml.get('BACKUP_VERSION_DATE_LABEL')}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name:'downloadBackup',
    data() {
        return {
            selectedDate:''
        }
    },
    computed:{
        lastWeek(){
            var lastWeek = []
            var today = this.$moment()
            for(var i = 0 ; i<7;i++){
                var day = this.$moment().add(-i,'days').format("YYYY-MM-DD 00:00") 
                lastWeek.push(day)
            }
            this.selectedDate = this.$moment(lastWeek[0]).format('YYYY-MM-DD')
            return lastWeek
        }
    },
    methods:{
        ...mapActions(['getDLLinkForCompanyBackups']),
        getDLLinkForCompanyBackupsF(){
            
            var form ={}
            form.backupDay = this.selectedDate
            this.getDLLinkForCompanyBackups(form).then((res)=>{return res}).then((res)=>{
                if(res.data.status.code==0){
                    window.open(res.data.content.url,'_blank')
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        }
    }
}
</script>
<style scoped>
    .list-group > li:nth-child(odd){
        background-color:#F4F4F4;
    }
    .list-group > li:hover{
        background-color:#f8f9fa!important;
    }
</style>